import { addDoc, arrayUnion, collection, doc, updateDoc } from "firebase/firestore";
import { where as liteWhere } from "firebase/firestore/lite";
import db from "../Firebase";
import { Messaging } from "../../models/Messaging.tsx";
import { getLiteQueryDocs } from "../../helpers/firestoreLiteQuery.ts";

export async function messaging(newMessage: Messaging): Promise<string> {
  try {
    const messagingRef = collection(db, 'messaging');
    const docRef = await addDoc(messagingRef, newMessage);
    return docRef.id;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function showMessaging(userId: string): Promise<Messaging[]> {
  try {
    const docs = await getLiteQueryDocs("messaging", [
      liteWhere("recipientUsers", "array-contains", userId),
    ]);

    const messages: Messaging[] = [];
    docs.forEach((docSnap) => {
      const messageData = docSnap.data() as Messaging;
      if (!messageData.deletedBy?.includes(userId)) {
        messages.push({
          ...messageData,
          id: docSnap.id
        });
      }
    });

    return messages;
  } catch (error) {
    console.error(error);
    throw new Error("Error fetching messages");
  }
}

export async function showMessagingSent(userId: string): Promise<Messaging[]> {
  try {
    const docs = await getLiteQueryDocs('messaging', [
      liteWhere("senderUser", "==", userId),
    ]);

    const messages: Messaging[] = [];
    docs.forEach((docSnap) => {
      const messageData = docSnap.data() as Messaging;
      if (!messageData.deletedBy?.includes(userId)) {
        messages.push({
          ...messageData,
          id: docSnap.id
        });
      }
    });

    return messages;
  } catch (error) {
    console.error(error);
    throw new Error("Error fetching sent messages");
  }
}

export async function deleteMessageForUser(messageId: string, userId: string): Promise<void> {
  try {
    const messageDoc = doc(db, "messaging", messageId);
    await updateDoc(messageDoc, {
      deletedBy: arrayUnion(userId)
    });
  } catch (error) {
    console.error(error);
    throw new Error("Error deleting message for user");
  }
}

export { isMessageUnread, markMessageAsRead, fetchUnreadMessageCount } from '../player/Messaging.tsx';


